import { NavLink } from "react-router-dom";
import "./Sidebar.css";

import { MdSpaceDashboard } from "react-icons/md";
import { FaClipboardList, FaHistory } from "react-icons/fa";
import { BiTransfer } from "react-icons/bi";
import { BsBoxSeam } from "react-icons/bs";
import { HiOutlineDocumentReport, HiOutlineNewspaper } from "react-icons/hi";
import { FiSettings, FiLogOut } from "react-icons/fi";
import { IoStorefront, IoPersonCircleSharp, IoPeopleSharp } from "react-icons/io5";
import { HiCurrencyDollar } from "react-icons/hi2";
import { IoIosHelpCircle } from "react-icons/io";

const navItemsTop = [
  {
    path: "/vendor/vendordashboard",
    label: (
      <>
        <MdSpaceDashboard style={{ marginRight: "12px" }} />
        Dashboard
      </>
    ),
  },
  {
    path: "/vendor/orders",
    label: (
      <>
        <FaClipboardList style={{ marginRight: "12px" }} />
        Orders
      </>
    ),
  },
  {
    path: "/vendor/exchange",
    label: (
      <>
        <BiTransfer style={{ marginRight: "12px" }} />
        Exchange
      </>
    ),
  },
  {
    path: "/vendor/products",
    label: (
      <>
        <BsBoxSeam style={{ marginRight: "12px" }} />
        Products
      </>
    ),
  },
  {
    path: "/vendor/stock",
    label: (
      <>
        <IoStorefront style={{ marginRight: "12px" }} />
        Stock
      </>
    ),
  },
  {
    path: "/vendor/reports",
    label: (
      <>
        <HiOutlineDocumentReport style={{ marginRight: "12px" }} />
        Reports
      </>
    ),
  },
  {
    path: "/vendor/invoiceandpayments",
    label: (
      <>
        <HiCurrencyDollar style={{ marginRight: "12px", textWrap: "nowrap" }} />
        Payments
      </>
    ),
  },
  {
    path: "/vendor/quotation",
    label: (
      <>
        <HiOutlineNewspaper style={{ marginRight: "12px", textWrap: "nowrap" }} />
        Quotation
      </>
    ),
  },
  {
    path: "/vendor/workers",
    label: (
      <>
        <IoPeopleSharp style={{ marginRight: "12px", textWrap: "nowrap" }} />
        Workers
      </>
    ),
  },
  {
    path: "/vendor/clients",
    label: (
      <>
        <IoPeopleSharp style={{ marginRight: "12px", textWrap: "nowrap" }} />
        Clients
      </>
    ),
  },
  {
    path: "/vendor/logs",
    label: (
      <>
        <FaHistory style={{ marginRight: "12px", textWrap: "nowrap" }} />
        Logs
      </>
    ),
  },
];

const navItemsBottom = [
  {
    path: "/vendor/profile",
    label: (
      <>
        <IoPersonCircleSharp style={{ marginRight: "12px" }} />
        Profile
      </>
    ),
  },
  {
    path: "/vendor/settings",
    label: (
      <>
        <FiSettings style={{ marginRight: "12px" }} />
        Settings
      </>
    ),
  },
  {
    path: "/vendor/help",
    label: (
      <>
        <IoIosHelpCircle style={{ marginRight: "12px" }} />
        Help
      </>
    ),
  },
];

const Sidebar = () => {
  return (
    <aside className="sidebar">
      <div className="logo">Company Logo</div>
      <ul className="nav-links">
        {/* Top nav items */}
        {navItemsTop.map((item) => (
          <li key={item.path}>
            <NavLink
              to={item.path}
              end
              className={({ isActive }) =>
                isActive ? "nav-item active" : "nav-item"
              }
            >
              {item.label}
            </NavLink>
          </li>
        ))}

        {/* Horizontal separator line */}
        <li className="separator" aria-hidden="true" />

        {/* Bottom nav items */}
        {navItemsBottom.map((item) => (
          <li key={item.path}>
            <NavLink
              to={item.path}
              end
              className={({ isActive }) =>
                isActive ? "nav-item active" : "nav-item"
              }
            >
              {item.label}
            </NavLink>
          </li>
        ))}

        {/* Logout link */}
        <li>
          <NavLink
            to="/signin"
            className={({ isActive }) =>
              isActive ? "nav-item active" : "nav-item"
            }
          >
            <FiLogOut style={{ marginRight: "12px" }} />
            Logout
          </NavLink>
        </li>
      </ul>
    </aside>
  );
};

export default Sidebar;
